<template>
  <van-popup v-model="openModal" @click-overlay="maskClicked" :close-on-click-overlay="false">
    <div class="m-pop">
      <div class="m-pop-box">
        <div class="m-pop-cont">
          <img class="m-pop-img" src="../../../../public/images/emot-info.png" alt="">
          <h4 class="m-pop-title">{{ showTitle || '温馨提示'}}</h4>
          <h5 class="m-pop-text" v-html="processing(showTxt)"></h5>
        </div>
        <div class="m-pop-foot">
          <!--this.$router.push({path: '/surveyReport/information'})-->
          <button class="btn" v-for="(item,index) in btnList" @click="btnClick(index)">{{item}}</button>
          <!--<button class="btn">完善信息</button>-->
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'

Vue.use(Popup)
export default {
  data () {
    return {
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: String,
      default: ''
    },
    showTxt: {
      type: String,
      default: ''
    },
    btnList: {
      type: Array,
      default: []
    }
  },
  computed: {
    openModal: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },
  watch: {
  },
  methods: {
    processing (text) {
      return text
    },
    btnClick (index) {
      this.$emit('btnClick', index)
    },
    maskClicked (e) {
      this.$emit('btnClick', 'mask')
    }
  },
  name: 'showHint'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
@import "@/assets/style/variables.scss";

.van-popup /deep/{
  background: transparent !important;
}
.m-pop {
  background: transparent;
  top:0;
  width: 310px;
  padding: 70px 0;
  .m-pop-box {
    width: 310px;
    border-radius: 15px;
    padding-bottom: 20px;
    font-size: 0;
    background-color: #ffffff;
    > img {
      width: 100%;
      height: 98px;
      border-radius: 15px 15px 0 0;
    }
    .m-pop-cont {
      position: relative;
      width: 100%;
      /*height: 140px;*/
      padding: 20px;
      text-align: center;
      .m-pop-img {
        position: absolute;
        top: -30%;
        left: 50%;
        width: 88px;
        height: 88px;
        transform: translateX(-50%);
      }
      h4 {
        font-weight: bold;
        line-height: 44px;
        font-size: 18px;
        color: #333333;
      }
      p {
        line-height: 24px;
        font-size: 14px;
        color: #666666;
      }
      .m-pop-title {
        line-height: 44px;
        padding: 30px 0 10px;
        font-size: 24px;
        font-weight: bold;
        color: $assertive;
      }
      .m-pop-text {
        line-height: 24px;
        font-size: 14px;
        text-align: left;
        color: #666666;
      }
    }
    p {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 16px;
      border-top: 1px solid #f5f5f5;
      color: $assertive;
    }
    .m-pop-foot {
      padding-top: 20px;
      text-align: center;
      display: flex;
      justify-content: space-around;
      .btn {
        height: 30px;
        line-height: 28px;
        padding: 0 24px;
        font-size: 14px;
        border-radius: 15px;
        &:first-child {
          margin-left: 20px;
          background-color: #ffffff;
          border: 1px solid $assertive;
          color: $assertive;
        }
        &:last-child {
          margin-right: 20px;
          background-color: $assertive;
          border: 1px solid $assertive;
          color: #ffffff;
        }
      }
    }
  }
}

</style>
